// src/api/bookingApi.js
import axios from "axios";

const BASE_URL = "https://api.taxitribe.com/api/bookings";

export async function getFareEstimate(data) {
  try {
    const response = await axios.post(
      `${BASE_URL}/getFareEstimateForScannedQr`,
      data
    );
    return response.data;
  } catch (err) {
    console.error("Fare estimate error:", err);
    return { success: false, message: "Server error" };
  }
}

export async function createBooking(data) {
  try {
    const response = await axios.post(`${BASE_URL}/createBookingFromQr`, data);
    return response.data;
  } catch (err) {
    console.error("Booking error:", err);
    return { success: false, message: "Server error" };
  }
}
